import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=0c867988&scoped=true&"
import script from "./FieldInfo.vue?vue&type=script&lang=js&"
export * from "./FieldInfo.vue?vue&type=script&lang=js&"
import style0 from "./FieldInfo.vue?vue&type=style&index=0&id=0c867988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c867988",
  null
  
)

export default component.exports